import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var PhoneIcon = (props, _ref) => {
  var {
    attrs
  } = _ref;
  var _a, _b, _c, _d;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var {
    width,
    height
  } = props;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.381 19.374",
    width: "".concat(width),
    height: "".concat(height),
    class: (_a = props.class) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, h("g", {
    fill: (_c = attrs["fill-color"]) !== null && _c !== void 0 ? _c : "none"
  }, [h("path", {
    d: "M1.3 5.084a4.719 4.719 0 0 1 .311-1.881 2.418 2.418 0 0 1 .954-1.134c.387-.24.787-.46 \n            1.187-.672a.6.6 0 0 1 .774.29c.369.6.73 1.205 1.111 1.8q.433.672.908 1.315a.633.633 0 0 \n            1-.132.919c-.207.132-.386.3-.588.444a2.325 2.325 0 0 0-.731 2.919 3.262 3.262 0 0 \n            0 .364.6 20.026 20.026 0 0 0 4.355 4.322 2.425 2.425 0 0 0 2.631.25 1.933 1.933 0 0 0 \n            .678-.569c.187-.24.37-.482.553-.721a.6.6 0 0 1 .892-.133c.446.308.888.627 1.343.922.579.372 \n            1.17.729 1.759 1.086a.62.62 0 0 1 .257.914c-.166.3-.334.6-.507.9a2.846 2.846 0 0 1-2.317 1.429 \n            7.429 7.429 0 0 1-3.243-.483 14.778 14.778 0 0 1-4.674-2.778 19.81 19.81 0 0 1-4.248-4.887 11.451 \n            11.451 0 0 1-1.492-3.731c-.084-.435-.114-.879-.145-1.121Z"
  }), h("path", {
    stroke: (_d = attrs["stroke-color"]) !== null && _d !== void 0 ? _d : "#2b5dff",
    "stroke-width": "1.3",
    d: "M.652 4.895c.065.5.1 1 .2 1.5a12.257 12.257 0 0 0 1.636 4 20.576 20.576 0 0 0 \n            4.523 5.1 15.185 15.185 0 0 0 4.578 2.673 7.964 7.964 0 0 0 3.68.515 3.374 3.374 0 \n            0 0 2.606-1.6c.219-.355.42-.721.619-1.086a1.228 1.228 0 0 0-.435-1.655q-1.642-.972-3.2-2.071a1.219 \n            1.219 0 0 0-1.694.3q-.283.375-.572.744a1.421 1.421 0 0 1-.787.508 1.878 1.878 0 0 1-1.627-.333 \n            19.489 19.489 0 0 1-3.559-3.361 9.758 9.758 0 0 1-.844-1.123 1.7 1.7 0 0 1 \n            .475-2.339c.2-.136.389-.3.584-.444a1.219 1.219 0 0 0 .286-1.684q-1.1-1.559-2.071-3.2A1.223 \n            1.223 0 0 0 3.51.835c-.45.228-.891.478-1.317.746a2.957 2.957 0 0 0-1.131 1.343 5.5 5.5 0 0 0-.41 1.971Z"
  })]));
};
PhoneIcon.inheritAttrs = false;